import { Col, Row, Label, Input } from "reactstrap";
import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import {
  getSingleMenuItemData,
  getMenuItemList,
  getStaffLeaveList,
  getStaffList,
  sendLeaveRequest,
  sendLeaveRequestSuccess,
  updateSingleMenuItem,
  updateSingleMenuItemSuccess,
} from "../../../store/actions";
import Select from "../../Common/AppSelect";
import { handleDateFormat } from "../../Common/HandleDateTime";
import Bank from "../../../store/bank/reducer";
import { faIcons } from "../../../pages/Settings/company/menus/fa.icons";
import NavigationMenu from "../../../store/navigationMenu/reducer";
import AppModal from "../../Common/AppModal";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

export default function EditAvailableMenuItem({
  modal,
  setModal,
  toggle,
  selectedAvailableMenuItem,
}) {
  const dispatch = useDispatch();
  const [updateAvailableMenuItem, setUpdateAvailableMenuItem] = useState({
    Icon: "",
    Name: "",
    Url: "#",
  });
  const { singleMenuItemDataAPI } = useSelector((state) => ({
    singleMenuItemDataAPI:
      state.NavigationMenu.singleMenuItemData?.menunavitem_data,
  }));
  useEffect(() => {
    if (isEmpty(selectedAvailableMenuItem)) return;
    dispatch(getSingleMenuItemData({ id: selectedAvailableMenuItem?.Id }));
  }, [selectedAvailableMenuItem]);

  useEffect(() => {
    if (isEmpty(singleMenuItemDataAPI)) return;
    setUpdateAvailableMenuItem({
      FlagPlaceholder: singleMenuItemDataAPI?.FlagPlaceholder,
      Icon: singleMenuItemDataAPI?.Icon,
      Id: singleMenuItemDataAPI?.Id,
      MenuNavOption_Id: singleMenuItemDataAPI?.MenuNavOption_Id,
      Name: singleMenuItemDataAPI?.Name,
      Url: singleMenuItemDataAPI?.Url,
    });
  }, [singleMenuItemDataAPI]);

  const handleUpdateAvailableMenuItem = () => {
    //
    dispatch(updateSingleMenuItem([updateAvailableMenuItem]));
  };

  const { updateSingleMenuItemSuccessAPI, updateSingleMenuItemSuccessLoading } =
    useSelector((state) => ({
      updateSingleMenuItemSuccessAPI:
        state.NavigationMenu.updateSingleMenuItemSuccess,
      updateSingleMenuItemSuccessLoading:
        state.NavigationMenu.updateSingleMenuItemSuccessLoading,
    }));

  useEffect(() => {
    if (isEmpty(updateSingleMenuItemSuccessAPI)) return;
    if (updateSingleMenuItemSuccessAPI?.status === 200) {
      toast.success(updateSingleMenuItemSuccessAPI?.message);
      // Change #100340 - "when i pressed update the modal still remained on
      // screen". The close was commented out, and nothing refreshed the
      // builder's item list, so the edit did not show either. Reload the list,
      // then close. A failure keeps the popup open with the error so the
      // change can be corrected and retried.
      dispatch(getMenuItemList());
      setModal(false);
    } else {
      toast.error(updateSingleMenuItemSuccessAPI?.message);
    }
    dispatch(updateSingleMenuItemSuccess([]));
  }, [updateSingleMenuItemSuccessAPI]);
  return (
    <AppModal
      open={modal}
      onClose={toggle}
      title="Edit Menu Item"
      icon={<EditOutlinedIcon />}
      headerAccent="indigo"
      size="sm"
      loading={updateSingleMenuItemSuccessLoading}
      loadingText="Saving…"
      onSubmit={handleUpdateAvailableMenuItem}
      submitLabel="Update"
      submitColor="success"
    >
          <div className={"mt-4"}>
            <h6> Create a Place holder menu Item</h6>
            <div>
              <div className={"d-flex flex-column align-items-start"}>
                <div style={{ width: "100%" }}>
                  <Select
                    placeholder={"Select Icon"}
                    value={{
                      label: (
                        <span>
                          <i className={updateAvailableMenuItem.Icon}></i>{" "}
                          <span>
                            {updateAvailableMenuItem.Icon.replace("-", " ")}
                          </span>
                        </span>
                      ),
                      value: updateAvailableMenuItem?.Icon,
                    }}
                    isClearable={true}
                    style={{ width: "100%" }}
                    options={faIcons.map((item) => ({
                      label: (
                        <span>
                          <i className={item}></i>{" "}
                          <span>{item.replace("-", " ")}</span>
                        </span>
                      ),
                      value: item,
                    }))}
                    onChange={(e) => {
                      setUpdateAvailableMenuItem((prev) => {
                        const temp = { ...prev };
                        temp.Icon = e?.value;
                        return temp;
                      });
                    }}
                  ></Select>
                </div>

                <div className={"w-100 mt-2"}>
                  <input
                    style={{ width: "100%" }}
                    placeholder={"Menu Item Name"}
                    autoFocus={true}
                    className={"form-control w-100"}
                    type="text"
                    value={updateAvailableMenuItem?.Name ?? ""}
                    onChange={(e) => {
                      setUpdateAvailableMenuItem((prev) => {
                        const temp = { ...prev };
                        temp.Name = e.target.value;
                        return temp;
                      });
                    }}
                  />
                </div>
                <div className={"w-100 mt-2"}>
                  <input
                    style={{ width: "100%" }}
                    placeholder={"Menu Item Url Link"}
                    autoFocus={true}
                    className={"form-control w-100"}
                    type="text"
                    value={updateAvailableMenuItem?.Url ?? ""}
                    onChange={(e) => {
                      setUpdateAvailableMenuItem((prev) => {
                        const temp = { ...prev };
                        temp.Url = e.target.value;
                        return temp;
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
    </AppModal>
  );
}
